import React, { useEffect, useState } from "react";
import { Divider, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { usePostCreatePart } from "../../hooks";
import {
  HubButtonGroup,
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
  HubHookFormPartSelect,
} from "../../components";

import { CreateCustomerPartFrom } from "./CreateCustomerPartFrom";
import CreateCustomerPartTemplate from "./CreateCustomerPartTemplate";
import { useDialogContext } from "../HubDialogWrapper";

const createOptions = [
  {
    id: 1,
    label: "Use Template",
  },
  {
    id: 2,
    label: "Find Part",
  },
];

const CreateCustomerPartContent = () => {
  const [selected, setSelected] = useState(1);
  const navigate = useNavigate();
  const {
    mutate: postCreatePart,
    isLoading,
    isSuccess,
    data,
  } = usePostCreatePart();

  const { onClose = () => {}, open: customerId } = useDialogContext();
  const requestCustomer = customerId === true;

  useEffect(() => {
    if (isSuccess && data?.id) {
      onClose();
      navigate(`/parts/${data?.id}`);
    }
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      customerId: requestCustomer ? formData.customerId : customerId,
      partNumber: formData.partNumber,
      partName: formData.partName,
      ...(formData.partId
        ? { partId: formData.partId[0]?.id }
        : { templateId: formData.templateId }),
    };
    postCreatePart(payload);
  };
  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="20px" alignItems="center">
          <Stack alignItems="center">
            <Typography variant="h6">Create a New Part</Typography>
            <Typography variant="caption">
              Create new part from scratch or from a template
            </Typography>
          </Stack>
          <CreateCustomerPartFrom requestCustomer={requestCustomer} />
          <Divider orientation="horizontal" flexItem />
          <HubButtonGroup
            buttons={createOptions}
            selected={selected}
            setSelected={setSelected}
          />
          {selected === 2 ? (
            <HubHookFormPartSelect />
          ) : (
            <CreateCustomerPartTemplate />
          )}
          <HubCancelSubmitGroup
            disabled={isLoading}
            isLoading={isLoading}
            label="Create Part"
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default CreateCustomerPartContent;
